import React from "react";

//CoreUI
import {
  CFormCheck
} from "@coreui/react";

//useForm
import {
  set,
  useForm
} from "react-hook-form";

//components
import Popup from "./Popup";

export default function PopupLastAccesses({ trigger, setTrigger, setLastAccess }) {

  const { register, handleSubmit } = useForm();

  const onSubmit = data => {
    setLastAccess(data.last_access);
  }

  return (
    <Popup title="Filtrar por último acesso" trigger={trigger} setTrigger={setTrigger}>
      <div className="sm-body">
        <form onSubmit={handleSubmit(onSubmit)}>
          <ul className="last-access-list">
            <li>
              <label className="label-last-accesses">
                <input type="radio" name="last_access" value="1" {...register("last_access")} />
                <span className="text-color">Últimos 7 dias</span>
              </label>
            </li>
            <li>
              <label className="label-last-accesses">
                <input type="radio" name="last_access" value="2" {...register("last_access")} />
                <span className="text-color">7 até 30 dias</span>
              </label>
            </li>
            <li>
              <label className="label-last-accesses">
                <input type="radio" name="last_access" value="3" {...register("last_access")} />
                <span className="text-color">30 dias até 1 ano</span>
              </label>
            </li>
            <li>
              <label className="label-last-accesses">
                <input type="radio" name="last_access" value="4" {...register("last_access")} />
                <span className="text-color">Mais de 1 ano</span>
              </label>
            </li>
          </ul>

          <div className="popup-footer">
            <button className="btn btn-primary" type="submit">Concluir</button>
            <button className="btn btn-light mr-20" type="submit" onClick={() => setTrigger(false)}>Cancelar</button>
          </div>
        </form>
      </div>
    </Popup>
  );
}